import { Modal } from 'antd';
import { getIrelandClearanceDraft, getIrelandSadDraft } from 'store/declarations/client';
import DocumentTable from 'views/declarations/common/summary-view/DocumentTable';
import { DocumentsDiv, SadDocTitle } from 'views/declarations/common/summary-view/SummaryView.styles';

type Props = {
    declarationId: string | undefined;
    open: boolean;
    onCancel: () => void;
};

const DocumentsModal = ({ open, declarationId, onCancel }: Props) => {
    return (
        <Modal
            centered
            width={762}
            open={open}
            onCancel={onCancel}
            footer={null}
            bodyStyle={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: '3.2rem',
                minHeight: '236px',
            }}
        >
            <>
                <DocumentsDiv>
                    <SadDocTitle>SAD Document</SadDocTitle>
                    <DocumentTable id={declarationId} request={getIrelandSadDraft} fileName="sad-document" />
                </DocumentsDiv>
                <DocumentsDiv>
                    <SadDocTitle>Clearance Slip</SadDocTitle>
                    <DocumentTable
                        id={declarationId}
                        request={getIrelandClearanceDraft}
                        fileName="clearanceslip-document"
                    />
                </DocumentsDiv>
            </>
        </Modal>
    );
};

export default DocumentsModal;
